var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "btn-group" },
    [
      _c(
        "b-button",
        {
          staticClass: "btn btn-outline-primary mr-2 edit",
          attrs: { variant: "outline-primary" },
          on: {
            click: function ($event) {
              return _vm.onEdit()
            },
          },
        },
        [_vm._v("\n    Editar "), _c("span", { staticClass: "icon-editar" })]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "btn mr-1",
          attrs: { variant: "outline-primary" },
          on: {
            click: function ($event) {
              return _vm.onDelete()
            },
          },
        },
        [_vm._v(" Eliminar "), _c("span", { staticClass: "icon-eliminar" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }